<template>
  <div class="sm:pb-1 sm:pr-1 w-full h-full">
    <div class="Scroll pt-4 sm:pt-0 pr-3 pl-10 sm:pl-8 w-full h-full overflow-hidden">
      <h1 class="text-sm text-white font-bold">Titik Lokasi</h1>
      <ul class="py-3">
        <li
          v-for="(item, index) in poi"
          :key="index"
          class="px-3 py-3 mb-1 flex gap-2 justify-start items-center bg-gray-100">
          <input
            @change="changePoi(index, $event)"
            :checked="item.enable === 'AKTIF'"
            type="checkbox">
          <span class="text-xs text-stone-900">{{ item.title }} {{ item.enabled }}</span>
        </li>
      </ul>
      <h1 class="text-sm text-white font-bold">Layer</h1>
      <ul class="py-3">
        <li
          v-for="(item, index) in layers"
          :key="index"
          class="px-3 py-3 mb-1 flex gap-2 justify-start items-center bg-gray-100">
          <input
            @change="changeLayer(index)"
            :checked="item.enable"
            type="checkbox">
          <span class="text-xs text-stone-900">{{ item.title }}</span>
        </li>
      </ul>
      <h1 class="text-sm text-white font-bold">Basemap</h1>
      <ul class="py-3">
        <li
          v-for="(item, index) in basemap"
          :key="index"
          class="px-3 py-3 mb-1 flex gap-2 justify-start items-center bg-gray-100">
          <input
            @change="changeBasemap(index)"
            :checked="item.id === activeBasemap.id"
            type="checkbox">
          <span class="text-xs text-stone-900">{{ item.title }}</span>
        </li>
      </ul>
      <h1 class="text-sm text-white font-bold">WPP</h1>
      <ul class="py-3">
        <li
          v-for="(item, index) in listWPP"
          :key="index"
          class="px-3 py-3 mb-1 flex gap-2 justify-start items-center bg-gray-100">
          <input
            @change="changeWPP(index, $event)"
            :checked="poi.wpp.aktif[item.wpp_id] || false"
            type="checkbox">
          <span class="text-xs text-stone-900">{{ item.wpp_name }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'MenuFilterMap',
  computed: {
    ...mapGetters([
      'poi',
      'activeBasemap',
      'basemap',
      'layers',
      'auth',
      'listWPP'
    ])
  },
  methods: {
    ...mapActions([
      'togglePoi',
      'toLoadBasemap',
      'toLoadLayers',
      'toChangeActiveBasemap',
      'toToggleLayer',
      'toLoadListWPP',
      'toToggleWPP'
    ]),
    changePoi: function (key, $event) {
      this.togglePoi({
        key,
        enable: $event.target.checked ? 'AKTIF' : 'TIDAK'
      })
    },
    changeLayer: function (layerIndex) {
      this.toToggleLayer(layerIndex)
    },
    changeBasemap: function (basemapIndex) {
      this.toChangeActiveBasemap(basemapIndex)
    },
    changeWPP: function (key, $event) {
      this.toToggleWPP({
        key,
        enable: $event.target.checked
      })
    }
  },
  mounted: async function () {
    await this.toLoadBasemap()
    await this.toLoadLayers()
    await this.toLoadListWPP()
  }
}
</script>
